import { pluralize } from '@travelata-libs/utils';
import { computed, type ComputedRef } from 'vue';
import { OFFERS_WORD_FORMS } from '../config';
import type { ProviderOffer, ProviderOfferData } from '../model/types';
import buildRoomProviders from './buildRoomProviders';

interface UseRoomProviders {
  providers: ComputedRef<ProviderOfferData[]>;
  offersCountText: ComputedRef<string>;
}

const useRoomProviders = (getOffers: () => ProviderOffer[]): UseRoomProviders => {
  const providers = computed(() => buildRoomProviders(getOffers()));

  const offersCountText = computed(() => pluralize(OFFERS_WORD_FORMS, providers.value.length));

  return { providers, offersCountText };
};

export default useRoomProviders;
